const renderItemCategory = (tags) => {
  if (tags && tags.length > 0) {
    if (tags.includes("materassi")) {
      return "Materassi";
    }
    if (tags.includes("topper")) {
      return "Topper";
    }
    if (tags.includes("guanciali")) {
      return "Cuscini";
    }
    if (tags.includes("letti")) {
      return "Letti";
    }
    if (tags.includes("reti")) {
      return "Reti";
    }
    return "Accessori";
  }
  return null;
};

const renderItemCategory2 = (tags) => {
  if (tags && tags.length > 0) {
    if (tags.includes("myform") || tags.includes("guanciali memory")) {
      return "MyForm";
    }
    if (tags.includes("molle")) {
      return "Molle";
    }
    if (tags.includes("hybrid")) {
      return "Hybrid";
    }
    if (tags.includes("guanciali lattice")) {
      return "Lattice";
    }
    if (tags.includes("guanciali piuma")) {
      return "Piuma";
    }
    if (tags.includes("guanciali fibra")) {
      return "Fibra";
    }
    if (tags.includes("fissa")) {
      return "Fissa";
    }
    if (tags.includes("elettrica")) {
      return "Elettrica";
    }
    if (tags.includes("copri materasso")) {
      return "Coprimaterasso";
    }
    if (tags.includes("copri rete")) {
      return "Coprirete";
    }
    if (tags.includes("copri guanciale")) {
      return "Copricuscini";
    }
    if (tags.includes("piumini")) {
      return "Piumini";
    }
  }
  return null;
};

const renderItemCategory3 = (tags) => {
  if (tags && tags.length > 0) {
    if (tags.includes("research")) {
      return "Research";
    }
    if (tags.includes("innovative")) {
      return "Innovative";
    }
    if (tags.includes("essential")) {
      return "Essential";
    }
    if (tags.includes("signature")) {
      return "Signature";
    }
    if (tags.includes("benessere")) {
      return "Benessere";
    }
    if (tags.includes("reti legno")) {
      return "Legno";
    }
    if (tags.includes("reti ferro")) {
      return "Metallo";
    }
  }
  return null;
};

const getItemObject = (product) => {
  const lowerCaseTags = product.tags.map((tag) => tag.toLowerCase());
  return {
    item_id: product.id,
    item_name: product.title,
    coupon: "",
    discount: product.discountValue,
    index: product.index,
    item_category: renderItemCategory(lowerCaseTags),
    item_category2: renderItemCategory2(lowerCaseTags),
    item_category3: renderItemCategory3(lowerCaseTags),
    item_variant: product.variantName ?? "",
    location_id: "",
    full_price: product.initialPrice,
    price: product.finalPrice,
    dorelan_dreams: product.isPromoDreams,
    quantity: product.quantity ? product.quantity : 1,
    list: "",
  };
};

const getItemObjectArray = async (products, vatMultiplier = 1.00, eventType = '') => {
  const arrayProducts = [];
  const updatedCartData = await getUpdatedCart();

  products.forEach((product, index) => {
    let initialPrice = product.compare_at_price
      ? product.compare_at_price
      : product.price;
    let finalPrice = product.price;
    let discountValue = product.compare_at_price
      ? product.compare_at_price - product.price
      : 0;
    const saleTag = product.tags.find((tag) => tag.includes("PROMO"));
    if (saleTag) {
      const saleValue = saleTag.split("-")[2]
        ? parseInt(saleTag.split("-")[2])
        : 0;
      if (saleValue && !product.compare_at_price) {
        discountValue = product.price * saleValue;
        finalPrice = product.price - discountValue;
      }
    }
    initialPrice = Math.round(initialPrice * vatMultiplier * 0.01);
    finalPrice = Math.round(finalPrice * vatMultiplier * 0.01);
    discountValue = Math.round(discountValue * vatMultiplier * 0.01);

    let isPromoDreams = 'n/d';
    let cartProduct;

    if(window.DiscountCheckbox.allDreamsProducts.find((id) => id == product.id)) {
      if (eventType === '') {
        if(updatedCartData) {
          // console.log(`updatedCartData:`, updatedCartData);
          cartProduct = updatedCartData.productsInCart.find((prod) => prod.product_id == product.id);
          if(cartProduct) {
            // console.log(cartProduct);
            if (cartProduct.discounts?.find((disc) => window.DiscountCheckbox.allDreamsCoupons.includes(disc.title))) {
              isPromoDreams = 'si';
              // console.log('Discount matched')
            } else {
              isPromoDreams = 'no';
            }
          }
        }
      } else if (eventType === 'addToCart') {
        let discountCheckboxElement = document.querySelector('.shopify-section--main-product #dreams-discount-checkbox');
        if (discountCheckboxElement) {
          if (discountCheckboxElement.checked) {
            isPromoDreams = 'si';
          } else {
            isPromoDreams = 'no';
          }
        }
      }
    }


    const finalProduct = {
      ...product,
      initialPrice,
      finalPrice,
      discountValue,
      index,
      isPromoDreams,
    };

    arrayProducts.push(getItemObject(finalProduct));
  });
  return arrayProducts;
};

const getUpdatedCart = async () => {
  let productsInCart = [];

  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  const cartData = await response.json();
  cartData['items'].forEach((item) => {
    productsInCart.push(item);
  });

  const updatedCartData = {productsInCart};

  return updatedCartData;
}
